import { Record } from 'immutable';

export default class DayRecord extends Record({
  type: undefined,
  name: undefined,
}) {
}
